import React from 'react';
import ReactDOM from 'react-dom/client';
import 'normalize.css';
import 'core-js/actual/array/to-sorted';

import {
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query';

import './index.css';
import App from './app';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </React.StrictMode>
);
